import React from "react";
import {getCharacterDatabaseData} from "../includes/axios/getCharacterDatabaseData.js";
import  "./comicDatabaseDisplay.css";
import "../../css/sharedStyles.css";
import { withRouter } from 'react-router-dom';
import {Provider, connect} from "react-redux";
import { BrowserRouter, Route, browserHistory, Switch, Link, Router} from "react-router-dom";
import { createBrowserHistory } from 'history';
import LoaderAnimation from "../loaderAnimation/loaderAnimation.js"

var ComicDatabaseDisplay = class ComicDatabaseDisplay extends React.Component{
    
    constructor(props) {
        super(props);
      }  

    componentDidMount(){
        
    }//end componentDidMount()
    

    render() {
      const routeBase = localStorage.getItem("routeBase"); 

      //console.log("Ready for comics?: " + this.props.comicDatabase.readyToShowComics);

      if(this.props.comicDatabase.readyToShowComics === true){
        return (
          <div>{     
              this.props.comicDatabase.comicDatabaseList.map(function(comic,index){
               if( index != this.props.comicDatabase.comicDatabaseList.length - 1){
                //console.log(comic);
                return <Link to={routeBase + "/comicDetail"} key={index}>
                    
                    <div key = {index} className = "comicDisplayContainer" 
                      onClick = {(id)=>{this.props.changeMainComic(comic) }} //duh
                    >
                      <img src={comic[2]} className = "comicPic"/>
                      <p className = "comicText">{comic[0]}</p>
                    </div>
                  </Link>
                }
              },this)
              }
          </div>
        );//end return
      }else{
        return <LoaderAnimation text = "Loading Comic Database" />
      }


    }//end render()
  }

  export default ComicDatabaseDisplay;


// WEBPACK FOOTER //
// ./src/components/comicDatabaseDisplay/comicDatabaseDisplay.js